import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ChooseImportDataTypeDialogComponent = {
    selector: "vcChooseImportDataTypeDialog",
    templateUrl:
        "/angular/components/voter-file/choose-import-data-type.component.html",
    bindings: {
        firstTime: "=",
        selectedType: "=?",
    },
    controller: class ChooseImportDataTypeDialogController {
        // * bindings for typescript compiler *
        public firstTime: any;
        public selectedType: any;
        // ************************************

        private readonly $scope: any;
        private readonly dialog: DialogUtils;
        private $window: any;

        public isLeaderView: boolean;
        public types = [
            {
                label: "Contacts with Addresses",
                key: "all",
                icon: "location_home",
                explainer:
                    "The names and the associated household/premise addresses",
            },
            {
                label: "Contacts only",
                key: "contacts",
                icon: "person",
                explainer:
                    "The names of the people you intend to target, commonly voters, leads or customers",
            },
            {
                label: "Addresses only",
                key: "houses",
                icon: "home",
                explainer:
                    "The household/premise address that you intend to visit. This does not include people's names",
            },
        ];

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            __app_type: string,
            $window: any
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.$window = $window;

            this.$scope.$on("$routeChangeStart", () => this.dialog.cancel());
            this.isLeaderView = __app_type === "LEADER";
        }

        $onInit() {
            this.selectedType = this.selectedType ?? this.types[0].key;
        }

        selectImportDataType(type: string): void {
            this.selectedType = type;
            this.dialog.hide(this.selectedType);
        }
    },
};

angular
    .module("voterFile")
    .component(
        ChooseImportDataTypeDialogComponent.selector,
        ChooseImportDataTypeDialogComponent
    );
